import { axios } from '@ori/axios';
import { formatToken } from "../utils";
const NOT_LOGGED_IN_USER_ID = -1;
export async function graphqlFetcher({
  query,
  variables,
  url,
  token,
  tenant,
  language,
  sourceAppName,
  customerId,
  onError
}) {
  const formattedToken = formatToken(token);
  const headers = {
    'Content-Type': 'application/json',
    ...(tenant && {
      'x-tenant-context': tenant
    }),
    ...(formattedToken && {
      Authorization: formattedToken
    }),
    ...(language && {
      'Accept-language': language
    }),
    ...(sourceAppName && {
      'x-client-application': sourceAppName
    }),
    ...(customerId != null && customerId !== NOT_LOGGED_IN_USER_ID && {
      'x-customer-context': customerId.toString()
    })
  };
  const requestData = {
    query,
    variables: variables ?? {}
  };
  try {
    const {
      data
    } = await axios.post('/graphql', requestData, {
      baseURL: new URL(url).origin,
      headers
    });
    if (data.data) {
      return data.data;
    }
    throw new Error('No response data from GQL server');
  } catch (error) {
    onError?.(error);
    throw new Error('Error from GQL server');
  }
}
//# sourceMappingURL=graphqlFetcher.js.map